import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import axios from "axios";

Vue.config.productionTip = false;

Vue.prototype.$http = axios;
Vue.prototype.$apiBaseURI = "https://www.miemss.org/lms-registration-service/api/";

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

axios.interceptors.request.use(
  (config) => {
    // const user = v.$root.user;
    // if (user) {
    //   const authToken = user.access_token;
    //   if (authToken) {
    //     config.headers.Authorization = `Bearer ${authToken}`;
    //   }
    // }
    config.headers["MIEMSS-Custom-Auth-Code"] = "05009132-BB42-4C19-BF26-96146EE8BC21";

    return config;
  },
  (err) => {
    //What do you want to do when a call fails?
    console.log(err);
  }
);